import { useEffect, useMemo, useState } from 'react';
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import styles from './DotBillbackTypeFilter.module.scss';

type DotBillbackTypeFilterProps = {
    dotBillbackType: string | undefined,
    onDotBillbackTypeChange: (value: string | undefined) => void,
    availableTypes: string[]
};

const DotBillbackTypeFilter = ({
    dotBillbackType,
    onDotBillbackTypeChange,
    availableTypes
}: DotBillbackTypeFilterProps) => {
    const [data, setData] = useState<string[]>(availableTypes);

    useEffect(() => {
        setData(availableTypes);
    }, [availableTypes]);

    const onFilterChange = ({ filter: { value } }: ComboBoxFilterChangeEvent) => {
        const search = value?.toLowerCase().trim() ?? '';
        setData(
            search.length > 0
                ? availableTypes.filter((type) =>
                    type.toLowerCase().includes(search)
                )
                : availableTypes
        );
    };

    const onChange = ({ value }: ComboBoxChangeEvent) => {
        onDotBillbackTypeChange(typeof value === 'string' ? value : undefined);
    };

    const selectedValue = useMemo(
        () => availableTypes.find((type) => type === dotBillbackType) ?? null,
        [availableTypes, dotBillbackType]
    );

    return (
        <span className={styles.container}>
            <span className={styles.label}>Billback Type:</span>
            <ComboBox
                className={styles.filter}
                data={data}
                value={selectedValue}
                onChange={onChange}
                placeholder="All"
                clearButton
                suggest
                allowCustom={false}
                filterable
                onFilterChange={onFilterChange}
                onOpen={() => setData(availableTypes)}
                size="small"
            />
        </span>
    );
};

export default DotBillbackTypeFilter;
